export const NOTIFICATION = 'Notifications';
export const NO_NOTIFICATION_MESSAGE = 'No Messages';
